import { Component, OnInit, OnDestroy, DoCheck, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, AuthenticationService, ShadowService } from 'src/app/shared/_services';
import { ModalController, Platform } from '@ionic/angular';
import { SelectPaymentMethodPage } from 'src/app/shared/modals/select-payment-method/select-payment-method.page';
import { LoginStore, PaymentsStore } from 'src/app/shared/_services/store';
import { CloseOverlayService } from 'src/app/shared/_services/closeOverlay.service';

@Component({
  selector: 'app-new-payment',
  templateUrl: './new-payment.page.html',
  styleUrls: ['./new-payment.page.scss']
})

export class NewPaymentPage implements OnInit, OnDestroy, DoCheck {
  @ViewChild('amountId', { static: false }) amountInput: any;
  paymentMethod = 'bankTransfer';
  header: any;
  amount: any;
  phone: any;
  bankCode: any;
  description: any;
  currentUser: any;
  subscription: any;
  cordova: boolean;
  desktop: boolean;
  selectBank = false;
  disabled = true;
  hideSpinner = true;
  banks = [];
  numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  numbersAfterDecimal: any;
  inputHasFocus: boolean;

  constructor(
    private router: Router,
    private platform: Platform,
    private route: ActivatedRoute,
    private loginStore: LoginStore,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private shadowService: ShadowService,
    private paymentsStore: PaymentsStore,
    private modalController: ModalController,
    private closeOverlayService: CloseOverlayService
  ) {
    this.currentUser = this.auth.currentUserValue;
   }

  displayNumber(num: any) {
    if (this.numbersAfterDecimal.length !== 2) {
      this.amount = this.amount.concat(num);
    }
  }

  addDecimal() {
    if (!this.amount.includes('.') && this.amount.length > 1) {
      this.amount = this.amount.concat('.');
    }
  }

  addZero() {
    if (parseInt(this.amount, 10) > 0 && this.numbersAfterDecimal.length !== 2) {
      this.amount = this.amount.concat(0);
    }
  }

  clear() {
    this.amount = '';
    this.numbersAfterDecimal = 0;
  }

  deleteNumber() {
    this.amount = this.amount.slice(0, -1);
  }

  async changePaymentMethod() {
    const modal = await this.modalController.create({
      component: SelectPaymentMethodPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      // mode: 'ios',
      cssClass: 'bottom-modal create-dispute h-50'
    });
    return await modal.present();
  }

  makeNewPayment() {
    this.paymentsStore.setAmount(this.amount);
    this.hideSpinner = false;
    this.disabled = true;
    if (this.paymentMethod === 'bankTransfer') {
      this.auth.bankTransferPayment(this.amount, this.phone, this.description)
      .subscribe(
        response => {
          console.log(response);
          this.paymentsStore.setBankTransferDetails(response);
          this.router.navigateByUrl('/confirm-payment');
          this.hideSpinner = true;
          this.disabled = false;
          this.clear();
        },
        error => {
          console.log(error);
          this.hideSpinner = true;
          this.disabled = false;
          if (error.error.message.includes('400') || error.status === 500) {
            this.alertService.standardAlert('Unable to make Payment. Please try again');
          } else {
            this.alertService.standardAlert('Unable to make Payment. Please try again');
          }
        }
      );
    } else {
      this.auth.ussdPayment(this.amount, this.bankCode)
      .subscribe(
        response => {
          console.log(response);
          this.paymentsStore.setUssdDetails(response);
          this.router.navigateByUrl('/confirm-payment');
          this.hideSpinner = true;
          this.clear();
        },
        error => {
          console.log(error);
          this.hideSpinner = true;
          if (error.error.message.includes('Minimum amount')) {
            this.alertService.standardAlert(error.error.message);
          } else {
            this.alertService.standardAlert('Unable to make Payment. Please try again');
          }
        }
      );
    }
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  ionViewWillEnter() {
    document.title = 'New Payment | Bank3D';
    this.shadowService.button();
  }

  ionViewDidEnter() {
    this.numbersAfterDecimal = 0;
    const { cbn } = this.banks.find(bank => bank.name);
    this.bankCode = cbn;
    const newPayment = 'new';
    if (this.route.snapshot.queryParams[newPayment]) {
      this.changePaymentMethod();
    }
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      this.goBack();
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.cordova = this.platform.is('cordova');
    this.desktop = this.platform.is('desktop');
    this.amount = '';
    this.banks = this.loginStore.getUssdBanks();
    this.bankCode = 0;
    // this.paymentsStore.setPaymentMethod('bankTransfer');
    window.onpopstate = (() => {
      this.closeOverlayService.trigger();
    });
    window.addEventListener('keydown', (e) => {
      const num = parseInt(e.key, 10);
      const pathname = window.location.pathname;
      document.querySelectorAll('ion-input').forEach(element => {
        this.inputHasFocus = element.classList.contains('has-focus');
      });
      if (!this.inputHasFocus) {
        if (num > 0 && num <= 9) {
          this.displayNumber(num);
        }
        if (num === 0) {
          this.addZero();
        }
        if (e.key === '.') {
          this.addDecimal();
        }
        if (e.key === 'Backspace') {
          this.deleteNumber();
        }
      }
      if (e.key === 'Enter' && this.disabled === false && pathname.includes('new-payment')) {
        this.makeNewPayment();
      }
      if (e.key !== 'Tab') {
        this.closeOverlayService.trigger();
      }
    });
  }

  ngDoCheck(): void {
    this.paymentMethod = this.paymentsStore.getPaymentMethod();
    if (this.paymentMethod === 'bankTransfer') {
      this.header = 'Bank Transfer';
      this.selectBank = false;
    } else if (this.paymentMethod === 'ussd') {
      this.header = 'USSD';
      this.selectBank = true;
    } else if (this.paymentMethod === 'cardPayment') {
      this.header = 'Card Payment';
      this.selectBank = false;
    }
    if (this.paymentMethod === 'bankTransfer' && this.amount.length > 1 ) {
      this.disabled = false;
    } else if (this.paymentMethod === 'ussd' && this.amount.length > 2 && this.bankCode.length === 3) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
    if (this.amount.indexOf('.') !== -1) {
      const remainder = this.amount.slice(this.amount.indexOf('.') + 1);
      this.numbersAfterDecimal = remainder;
    }
  }

  ngOnDestroy() {
  }

}
